/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'swiper/css';
import 'swiper/css/pagination';

import { GatsbyBrowser } from 'gatsby';

import { WrapRootElement } from './src/commons/wrapRootElement';

export const wrapRootElement = WrapRootElement;

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = (
  {
    pathname,
    routerProps: { location },
    getSavedScrollPosition,
  }) => {

  const isSpecialist = /\/spezialisten\/(\W+|\w+)*/.test(pathname);
  const transitionDelay = isSpecialist ? 1000 : 25;

  window.history.scrollRestoration = "manual"
  const currentPosition = getSavedScrollPosition(location)
  setTimeout(() => {
    window.scrollTo(...(isSpecialist ? [0, 0] : (currentPosition || [0, 0])));
    if (isSpecialist) {
      document.querySelectorAll<HTMLAnchorElement>('#header-logo')[0].focus();
    }
  }, transitionDelay);

  return false;
};
